import { render } from "./SignUp.vue?vue&type=template&id=440e8640&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=440e8640&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-440e8640"

export default script